document.addEventListener('DOMContentLoaded', function () {
  // Function to disable swiping on a Swiper instance
  function disableSwipingOnGallery(swiperInstance) {
    if (swiperInstance) {
      console.log('Disabling swiping for:', swiperInstance);
      swiperInstance.allowSlideNext = false;
      swiperInstance.allowSlidePrev = false;
      swiperInstance.allowTouchMove = false;
      swiperInstance.slideTo(0); // Ensure it shows the first slide
    }
  }

  // Set to keep track of galleries that have been processed
  var processedGalleries = new Set();

  // Function to check for Swiper instances and disable swiping
  function checkAndDisableSwiping() {
    var swiperContainers = document.querySelectorAll('.xo-gallery .xo-slider .swiper-container.xo-slide-main');

    swiperContainers.forEach(function (swiperEl) {
      if (!processedGalleries.has(swiperEl)) {
        var swiperInstance = swiperEl.swiper;
        if (swiperInstance) {
          disableSwipingOnGallery(swiperInstance);
          processedGalleries.add(swiperEl);
        }
      }
    });

    // If all swiperContainers have been processed, clear the interval
    if (processedGalleries.size === swiperContainers.length) {
      clearInterval(swiperCheckInterval);
      console.log('All galleries have been processed. Interval cleared.');
    }
  }

  // Set up interval to check every 500ms
  var swiperCheckInterval = setInterval(checkAndDisableSwiping, 500);
});